import { request } from '@socgress/lib/api';
const botsApi = {
    login: request('login', 'POST'),
    register: request('register', 'POST'),
    getUser: request('user'),
};
export { botsApi };
